export default {
  title: 'Myyntitiimin raportti',
  fields: {
    name: 'Nimi',
    area: 'Alue',
    signed: 'Allekirjoitettu',
    live: 'Live',
  },
  buttons: {
    download_report: 'Lataa raportti',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui, päivitä sivu',
  },
};
